export const filterImmunizationRecords = (
  immunizationRecords,
  statuses = ['overdue', 'pending'],
) =>
  Object.entries(immunizationRecords)
    .filter((r) => statuses.includes(r[1].immunization_record_status))
    .map((r) => ({ key: r[0], ...r[1] }));
